import { create } from 'zustand';

import { EQueryIdType, IExplorerFilter } from '@src/emp-3.0/types';

export enum DATA_STAUS {
  RECEIVE = 'Receiving...',
  STOP = 'Stopped',
}
export type DataStatus = DATA_STAUS.RECEIVE | DATA_STAUS.STOP;
export interface IExplorerStore {
  explorerFilter: IExplorerFilter;
  setExplorerFilter: (data: Partial<IExplorerFilter>) => void;
  receivingData: DataStatus;
  setReceivingData: (receivingData: DataStatus) => void;
  startTime: string;
  setStartTime: (startTime: string) => void;
  enableReceive: boolean;
  setEnableReceive: (enableReceive: boolean) => void;
  eventCatchData: any;
  setEventCatchData: (eventCatchData: any) => void;
  summaryData: any;
  setSummaryData: (userCatchData: any) => void;
  stopManual: boolean;
  setStopManual: (stopManual: boolean) => void;
  resetLiveLensData: () => void;
  setAutoScroll: (autoScroll: boolean) => void;
  autoScroll: boolean;
}

const defaultExplorerFilter: IExplorerFilter = {
  client_id: '',
  user_id: '',
  device_name: '',
  application_version: '',
};

export const useExplorerStore = create<IExplorerStore>((set) => ({
  explorerFilter: defaultExplorerFilter,
  setExplorerFilter: (data) => {
    set((state) => {
      const newExplorerFilter: IExplorerFilter = { ...state.explorerFilter, ...data };

      return { explorerFilter: { ...newExplorerFilter } };
    });
  },
  receivingData: DATA_STAUS.STOP,
  setReceivingData: (receivingData) => {
    set({ receivingData });
  },
  startTime: '',
  setStartTime: (startTime) => {
    set({ startTime });
  },
  enableReceive: false,
  setEnableReceive: (enableReceive) => {
    set({ enableReceive });
  },
  eventCatchData: [],
  setEventCatchData: (eventCatchData) => {
    set({ eventCatchData });
  },
  summaryData: [],
  setSummaryData: (summaryData) => {
    set({ summaryData });
  },
  stopManual: true,
  setStopManual: (stopManual) => {
    set({ stopManual });
  },
  resetLiveLensData: () => {
    set({
      explorerFilter: defaultExplorerFilter,
      receivingData: DATA_STAUS.STOP,
      startTime: '',
      enableReceive: false,
      eventCatchData: [],
      summaryData: [],
      stopManual: true,
    });
    useExplorerIdStore.getState().resetExplorerId();
  },
  autoScroll: true,
  setAutoScroll: (autoScroll) => {
    set({ autoScroll });
  },
}));
export interface IExplorerIdStore {
  titleValue: EQueryIdType;
  setTitleValue: (titleValue) => void;
  selectedId: string[];
  setSelectedId: (selectedId: string[]) => void;
  resetExplorerId: () => void;
  defaultIpvValue: string[];
  setDefaultIpvValue: (defaultIpvValue: string[]) => void;
}
export const useExplorerIdStore = create<IExplorerIdStore>((set) => ({
  titleValue: EQueryIdType.ip,
  setTitleValue: (titleValue) => {
    set({ titleValue });
  },
  selectedId: [],
  setSelectedId: (selectedId) => {
    set({ selectedId });
  },
  resetExplorerId: () => {
    set({
      titleValue: EQueryIdType.ip,
      selectedId: useExplorerIdStore.getState().defaultIpvValue || [],
    });
  },
  defaultIpvValue: [],
  setDefaultIpvValue: (defaultIpvValue) => {
    set({ defaultIpvValue });
  },
}));
